module.exports = __webpack_public_path__ + "img/02-6月报.94ffcd5a.svg";